import React from 'react';
import { Box, Stack, AppBar, Toolbar, Typography, Container } from 'investira.react.components';
import EntidadeAvaliacaoProvider, {
  useEntidadeAvaliacaoContext
} from '../../../contexts/EntidadeAvaliacaoContext';
import { ErrorBoundary, PessoaImage } from '../../molecules';
import Main from './Main';
import { EntidadeThemeProvider } from '../../../providers';

const APPBAR_HEIGHT = 64;
const LOGO_PESSOA_ID = 1;
const ENTIDADE_NOME = 'Investira';

const EntidadeTemplateContent = props => {
  const { state } = useEntidadeAvaliacaoContext();
  const xLogoPessoaId = state.avaliacao?.entidade_ifeed_pessoa_id || LOGO_PESSOA_ID;
  const xEntidadeNome = state.avaliacao?.entidade || ENTIDADE_NOME;
  const { children } = props;

  return (
    <ErrorBoundary>
      <Box
        id="entidade"
        sx={{
          flexGrow: 1,
          width: '100vw',
          backgroundColor: 'background.dark'
        }}>
        <Stack id="app-bar-area" sx={{ height: APPBAR_HEIGHT }}>
          <AppBar position="static" elevation={0}>
            <Stack
              id="appbar"
              sx={{
                height: 'inherit'
              }}
              spacing={3}>
              <Toolbar sx={{ px: 2 }}>
                <Container maxWidth="xl">
                  <Stack direction="row" gap={2} alignItems="center">
                    <PessoaImage
                      logoPessoaId={xLogoPessoaId}
                      alt={xEntidadeNome}
                      hasLogo={true}
                      size={42}
                    />
                    <Typography variant="h6" color="textPrimary" sx={{ fontWeight: 500 }}>
                      {xEntidadeNome}
                    </Typography>
                  </Stack>
                </Container>
              </Toolbar>
            </Stack>
          </AppBar>
        </Stack>
        <Stack id="content-area" sx={{ height: `calc(100% - ${APPBAR_HEIGHT}px)` }}>
          <Main>{children}</Main>
        </Stack>
      </Box>
    </ErrorBoundary>
  );
};

const EntidadeTemplate = props => {
  const { children } = props;

  return (
    <EntidadeAvaliacaoProvider>
      <EntidadeThemeProvider>
        <EntidadeTemplateContent>{children}</EntidadeTemplateContent>
      </EntidadeThemeProvider>
    </EntidadeAvaliacaoProvider>
  );
};

export default EntidadeTemplate;
